import dayjs from "dayjs";

export const SLOT_MINUTES = 15;

// Minimum prep time before the first offered slot. The first slot is then
// rounded up to the next quarter hour, so real lead time is 20-35 min.
export const LEAD_MINUTES = 15; // kitchen prep time before the first slot
export const LAST_ORDER_BUFFER = 15; // stop taking pickups this long before close

// minutes from midnight
const at = (hour, minute = 0) => hour * 60 + minute;

const WEEKDAY = [
  [at(11), at(14, 15)], // closes 2:15 → last pickup 2:00 PM
  [at(15, 15), at(21)], // closes 9:00 → last pickup 8:45 PM
];

const WEEKEND = [
  [at(15, 15), at(21)], // dinner only
];

// Open windows per weekday, 0 = Sunday. Both ends inclusive: [11:00, 14:00]
// offers 11:00 AM through 2:00 PM. Split a window to create a break.
// >>> Replace these with Ken's real hours. <<<

export const SERVICE_HOURS = {
  0: WEEKEND, // Sunday
  1: WEEKDAY,
  2: WEEKDAY,
  3: WEEKDAY,
  4: WEEKDAY,
  5: WEEKDAY,
  6: WEEKEND, // Saturday
};

export const DATE_OVERRIDES = {
  "2026-12-25": [],
  "2026-12-26": [],
  "2026-12-24": [[at(11), at(15)]],
  "2027-01-01": [],
};

const roundUpToSlot = (minutes) =>
  Math.ceil(minutes / SLOT_MINUTES) * SLOT_MINUTES;

// Set hour/minute rather than adding to start-of-day: adding across a DST
// transition shifts the wall-clock label by an hour twice a year.
const labelFor = (day, minutes) =>
  day
    .hour(Math.floor(minutes / 60))
    .minute(minutes % 60)
    .second(0)
    .format("hh:mm A");

export const windowsFor = (day) =>
  DATE_OVERRIDES[day.format("YYYY-MM-DD")] ?? SERVICE_HOURS[day.day()] ?? [];

/**
 * @returns {{ minutes: number, label: string }[]}
 */
export function getPickupSlots(now = dayjs()) {
  const windows = windowsFor(now);
  if (!windows.length) return [];

  const earliest = roundUpToSlot(now.hour() * 60 + now.minute() + LEAD_MINUTES);

  const slots = [];
  for (const [open, close] of windows) {
    const start = Math.max(earliest, roundUpToSlot(open));
    const lastSlot = close - LAST_ORDER_BUFFER;
    for (let m = start; m <= lastSlot; m += SLOT_MINUTES) {
      slots.push({ minutes: m, label: labelFor(now, m) });
    }
  }
  return slots;
}

/** Guard for submit time - the slot list can go stale while the form sits open. */
export function isPickupSlotValid(label, now = dayjs()) {
  if (!label) return false;
  return getPickupSlots(now).some((slot) => slot.label === label);
}

export const isOpenNow = (now = dayjs()) => {
  const minutes = now.hour() * 60 + now.minute();
  return windowsFor(now).some(
    ([open, close]) => minutes >= open && minutes <= close,
  );
};
